import type { RouteObject } from 'react-router';

import { lazyComponent } from '../../../lazy-component';
import { couponsLoader } from './coupons-loader';

export const couponsRoutes: RouteObject = {
  loader: couponsLoader,
  children: [
    {
      path: '/coupons',
      lazy: lazyComponent(() => import('@pages/client/coupon/coupon-page'), 'CouponPage'),
    },
  ],
};
